import { Box, Tooltip } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import type { ButtonSizes, ButtonVariants } from '@repo/foundations';
import { Button } from '@repo/foundations';

export function UpgradeButton(props: {
	tooltip?: string;
	feature?: string;
	size?: ButtonSizes;
	variant?: ButtonVariants;
}) {
	const { tooltip, feature, size = 'sm', variant = 'primary' } = props;

	const handleUpgradeClick = () => {
		showNotification({
			title: `${feature} upgrade selected`,
			message: 'A Secoda team member will reach out to you soon',
			autoClose: false,
		});
	};

	const innerRender = (
		<Box style={{ width: 'max-content' }}>
			<Button size={size} onClick={handleUpgradeClick} variant={variant}>
				Upgrade
			</Button>
		</Box>
	);

	if (tooltip) {
		return <Tooltip label={tooltip}>{innerRender}</Tooltip>;
	}
	return innerRender;
}
